import { brandColors } from '@config/brandTokens';

/** Prominent age badge for frame titles and skill headers. */
export const ageHighlightBadgeSx = {
  height: 28,
  fontWeight: 900,
  fontSize: '0.82rem',
  letterSpacing: 0.4,
  bgcolor: brandColors.blue,
  color: brandColors.white,
  border: '2px solid #93c5fd',
  boxShadow: '0 2px 8px rgba(74,111,235,0.35)',
  '& .MuiChip-label': { px: 1.35 },
} as const;

export const agePillButtonSx = (selected: boolean) => ({
  minWidth: 52,
  px: 1.5,
  py: 0.65,
  borderRadius: '999px',
  textTransform: 'none' as const,
  fontWeight: 700,
  fontSize: '0.82rem',
  lineHeight: 1.2,
  color: selected ? brandColors.white : brandColors.slate,
  bgcolor: selected ? brandColors.blue : brandColors.white,
  border: `1px solid ${selected ? brandColors.blue : '#d8dee9'}`,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: selected ? '#3a56c9' : '#eef2f8',
    borderColor: brandColors.blue,
  },
});
